import NotificationModal from '@anm/components/modals/NotificationModal';
import useNotifications, { NotificationElement } from '@anm/hooks/useNotifications';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';

import { subscriptionSelectors } from '../../../store/modules/subscription';

const Notification: FC<NotificationElement> = ({ id, deleteNotification, ...rest }) => {
  const onModalClose = useCallback(() => {
    deleteNotification(id);
  }, [deleteNotification, id]);

  return <NotificationModal key={id} variant="aside" timeout={7000} {...{ onModalClose, ...rest }} />;
};

const Notifications: FC = () => {
  const deleteCardEntity = useSelector(subscriptionSelectors.selectDeleteCardState);
  const { notifications } = useNotifications({
    errorTitle: 'Error',
    errorMessage: 'Something went wrong!',
    successTitle: 'Success',
    successMessage: 'The card has been successfully deleted',
    ...deleteCardEntity
  });

  return (
    <>
      {notifications.map((props: NotificationElement) => (
        <Notification {...props} />
      ))}
    </>
  );
};

export default Notifications;
